import { render, staticRenderFns } from "./CopySocialContentEditor.vue?vue&type=template&id=041e1798"
import script from "./CopySocialContentEditor.vue?vue&type=script&lang=js"
export * from "./CopySocialContentEditor.vue?vue&type=script&lang=js"
import style0 from "./CopySocialContentEditor.vue?vue&type=style&index=0&id=041e1798&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports